import { useEffect, useState } from 'react';
import { FALLBACK_LANGUAGES, type LanguageOption } from '../lib/locale';
import { loadLanguageList } from '../i18n';

// One fetch of /locales/index.json per page load: the user menu opens often.
let list: Promise<LanguageOption[]> | null = null;

/** The languages offered (shipped two until index.json arrives). Shared by the user menu and Appearance. */
export function useLanguageList(): LanguageOption[] {
  const [languages, setLanguages] = useState<LanguageOption[]>(FALLBACK_LANGUAGES);
  useEffect(() => {
    let live = true;
    void (list ??= loadLanguageList()).then((l) => live && setLanguages(l));
    return () => {
      live = false;
    };
  }, []);
  return languages;
}
